import styled from 'styled-components';
import Button from '../../Button/Button';

// Shared Sell-From-Home secondary CTA (outlined). Pins the primaryOutlined
// variant and the SFH 16px type spec so it stays consistent with
// SfhPrimaryButton across every screen. `&&` outranks Button's base +
// mediaBelow(bpMd) font-size rules so 16px holds at every breakpoint.
// Variant colors come from themeColors tokens — do not hardcode them here.
const SfhSecondaryButton = styled(Button).attrs({
  variant: 'primaryOutlined',
  textTransform: 'none',
})`
  && {
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
`;

export default SfhSecondaryButton;
